import React from 'react';

import { FormattedMessage, useIntl } from '../../util/reactIntl';
import Modal from '../Modal/Modal';
import { PrimaryButton, SecondaryButton } from '../Button/Button';

import css from './JoinWindowModal.module.css';

const whenLabel = (startMs, intl) => {
  if (!Number.isFinite(startMs)) {
    return '';
  }
  return intl.formatDate(new Date(startMs), {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

/**
 * Explain why Join did not open the live session.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {'too_early'|'ended'|null} props.status
 * @param {number} [props.startMs]
 * @param {Function} props.onClose
 * @param {Function} [props.onBackToInbox]
 * @param {Function} props.onManageDisableScrolling
 * @returns {JSX.Element}
 */
const JoinWindowModal = props => {
  const { isOpen, status, startMs, onClose, onBackToInbox, onManageDisableScrolling } = props;
  const intl = useIntl();
  const ended = status === 'ended';
  const when = whenLabel(startMs, intl);

  return (
    <Modal
      id="JoinWindowModal"
      isOpen={!!isOpen && (status === 'too_early' || ended)}
      onClose={onClose}
      onManageDisableScrolling={onManageDisableScrolling}
      containerClassName={css.container}
      contentClassName={css.content}
    >
      <div className={css.body}>
        <p className={css.kicker}>
          <FormattedMessage id="JoinWindowModal.kicker" />
        </p>
        <h2 className={css.title}>
          {ended ? (
            <FormattedMessage id="JoinWindowModal.endedTitle" />
          ) : (
            <FormattedMessage id="JoinWindowModal.tooEarlyTitle" values={{ when }} />
          )}
        </h2>
        <p className={css.lede}>
          <FormattedMessage
            id={ended ? 'JoinWindowModal.endedBody' : 'JoinWindowModal.tooEarlyBody'}
          />
        </p>
        <div className={css.actions}>
          {ended && typeof onBackToInbox === 'function' ? (
            <PrimaryButton type="button" className={css.primary} onClick={onBackToInbox}>
              <FormattedMessage id="JoinWindowModal.backToInbox" />
            </PrimaryButton>
          ) : (
            <PrimaryButton type="button" className={css.primary} onClick={onClose}>
              <FormattedMessage id="JoinWindowModal.ok" />
            </PrimaryButton>
          )}
          {ended ? (
            <SecondaryButton type="button" className={css.secondary} onClick={onClose}>
              <FormattedMessage id="JoinWindowModal.dismiss" />
            </SecondaryButton>
          ) : null}
        </div>
      </div>
    </Modal>
  );
};

export default JoinWindowModal;
